export default __webpack_public_path__ + "fd2d08ce9c7a23eeb15da446920e8a74.png";